export const LangText: any = {
    jp: {
        product_name: 'EcoFlow DELTA 3 1000 Air',
        tab_product: '概要',
        tab_bundles: 'Bundles',
        tab_support: 'サポート',
        tab_specs: '仕様',
        tab_media: 'Media',
        btn_buy: '今すぐ購入',
        btn_buy2: '今すぐ購入',
    },
};
